<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<section class="overlay-panel-container d-flex flex-column">
    <div class="overlay-panel-content d-flex flex-column left-align" *ngIf="openPanel" [@slideInLeft]>
        <header class="rm-header d-flex justify-content-between align-items-center">
            <div class="row mobile-menu">
                <div class="col-2">
                    <button mat-icon-button class="close-button-2" (click)="close()">
                        <mat-icon class="text-white">close</mat-icon>
                    </button>
                </div>

                <div class="col-10">
                    <ul class="avantor-utility d-flex align-items-center justify-content-end">
                        <li>
                            <ng-container *ngIf="notifications.length != 0">
                                <button class="action-button mr-3" color="primary" [matMenuTriggerFor]="
                                        headerNotificationMenu
                                    ">
                                    <div class="notif-badge-container" *ngIf="notifCount > 0">
                                        <div class="notif-badge d-flex align-items-center justify-content-center">
                                            {{ notifCount }}
                                        </div>
                                    </div>
                                    <img src="/icons/notification-icon-white.svg" alt="" />
                                </button>
                            </ng-container>
                            <ng-container *ngIf="notifications.length == 0">
                                <button class="action-button mr-3" color="primary">
                                    <img src="/icons/notification-icon-white.svg" alt="" />
                                </button>
                            </ng-container>

                            <mat-menu #headerNotificationMenu="matMenu" xPosition="before" class="header-notification">
                                <div class="notif-item-container">
                                    <div class="notif-item" *ngFor="
                                            let notification of notifications
                                        ">
                                        <div class="text-primary font-weight-bold">
                                            {{ notification.subject }}
                                        </div>
                                        <div class="text-secondary notif-body">
                                            <p class="mb-0" [innerHtml]="
                                                    notification.body
                                                "></p>
                                        </div>
                                        <div class="text-secondary">
                                            {{
                                            notification.createdDateString || (notification.createdDate |
                                            globalDateTime)
                                            }}
                                        </div>
                                        <mat-divider class="my-1"></mat-divider>
                                    </div>
                                </div>
                                <div class="notif-footer w-100">
                                    <a mat-button (click)="close()" routerLink="communications/notifications"
                                        class="notif-footer-btn w-100 px-1 text-primary text-left font-weight-bold">
                                        {{ 'ime.see.all' | translate }} >>
                                    </a>
                                </div>
                            </mat-menu>
                        </li>
                        <li>
                            <button class="action-button d-flex align-items-center mr-3"
                                [matMenuTriggerFor]="getHelpMenu" (menuOpened)="initializeChat()"
                                (click)="getUserManaulaId()">
                                <mat-icon>help</mat-icon>
                            </button>

                            <mat-menu xPosition="before" #getHelpMenu="matMenu" class="user-menu">
                                <button mat-menu-item (click)="toggleNewsPanel()">
                                    <div class="d-flex">
                                        <div class="notif-badge-container" *ngIf="newsCount > 0">
                                            <div class="notif-icon news">
                                                {{ newsCount }}
                                            </div>
                                        </div>
                                        <img width="20" height="20" class="menu-icon" src="/icons/news-icon-blue.svg"
                                            alt="" />
                                        <div class="px-1">
                                            <div class="menu-item-title">
                                                {{
                                                'ime.news.and.updates'
                                                | translate
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </button>
                                <button mat-menu-item (click)="toggleUserPanel()">
                                    <div class="d-flex">
                                        <img width="20" height="20" class="menu-icon"
                                            src="/icons/user-menu-apps-icon.svg" alt="" />
                                        <div class="px-1">
                                            <div class="menu-item-title">
                                                {{ 'User Manual' | translate }}
                                            </div>
                                        </div>
                                    </div>
                                </button>

                                <button mat-menu-item (click)="onStartChat()" #liveAgentOnline>
                                    <div class="d-flex">
                                        <div class="notif-badge-container">
                                            <div class="notif-icon"></div>
                                        </div>
                                        <img width="20" height="20" class="menu-icon" src="/icons/bubble-chat-blue.svg"
                                            alt="" />
                                        <div class="px-1">
                                            <div class="menu-item-title">
                                                {{
                                                'ime.chat.support'
                                                | translate
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </button>
                                <button mat-menu-item
                                    (click)="navigateToPage(SITE_LINK.FREQUENTLY_ASKED_QUESTIONS.BASE)">
                                    <div class="d-flex">
                                        <img width="20" height="20" class="menu-icon" src="/icons/help-icon.svg"
                                            alt="" />
                                        <div class="px-1">
                                            <div class="menu-item-title">
                                                {{ 'ime.faqs' | translate }}
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </mat-menu>
                        </li>
                        <li>
                            <button class="action-button d-flex align-items-center mr-3" (click)="close()"
                                [routerLink]="SITE_LINK.COMMUNICATIONS.BASE">
                                <div class="notif-badge-container" *ngIf="messageCount > 0">
                                    <div class="notif-badge d-flex align-items-center justify-content-center">
                                        {{ messageCount }}
                                    </div>
                                </div>
                                <img width="20" height="20" src="/icons/chat-icon.svg" alt="" />
                            </button>
                        </li>
                        <li>
                            <button class="action-button d-flex align-items-center mr-3" [matMenuTriggerFor]="userMenu">
                                <img width="20" height="20" src="/icons/account-icon.svg" alt="" />
                            </button>
                            <mat-menu xPosition="before" #userMenu="matMenu" class="user-menu">
                                <span class="sm-username">
                                    {{ 'welcome' | translate }},
                                    {{ userData?.firstName | titlecase }}
                                </span>
                                <button mat-menu-item (click)="close()" [routerLink]="
                                        SITE_LINK.ACCOUNT_SETTINGS.BASE
                                    ">
                                    <div class="d-flex">
                                        <img class="menu-icon" src="/icons/user-menu-settings-icon.svg" alt="" />
                                        <div class="px-1">
                                            <div class="menu-item-title">
                                                {{
                                                'ime.account.settings'
                                                | translate
                                                }}
                                            </div>
                                            <div class="menu-item-description">
                                                {{
                                                'ime.account.settings.desc'
                                                | translate
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </button>
                                <button mat-menu-item>
                                    <div class="d-flex">
                                        <img class="menu-icon" src="/icons/user-menu-apps-icon.svg" alt="" />
                                        <div class="px-1">
                                            <div class="menu-item-title">
                                                {{
                                                'ime.sites.applications'
                                                | translate
                                                }}
                                            </div>
                                            <div class="menu-item-description">
                                                {{
                                                'ime.sites.applications.desc'
                                                | translate
                                                }}
                                                <hr />
                                                <div *ngFor="
                                                        let widget of widgetData
                                                    ">
                                                    <a class="menu-item-title jump-url" href="{{ widget.url }}"
                                                        target="_blank">{{ widget.name }}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                                <button mat-menu-item (click)="logout()">
                                    <div class="d-flex align-items-center">
                                        <img class="menu-icon" src="/icons/user-menu-logout-icon.svg" alt="" />
                                        <div class="px-1">
                                            <div class="menu-item-title">
                                                {{ 'im.logout' | translate }}
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </mat-menu>
                        </li>
                    </ul>
                </div>
            </div>
            <button mat-icon-button class="tablet-close-button" (click)="close()">
                <mat-icon class="text-white">close</mat-icon>
            </button>

            <div class="avantor-app d-flex align-items-center" routerLink="">
                <img class="app-logo" src="/images/avantor-white-txt.svg" alt="" width="159" height="20" />
                <span class="app-title">{{ 'inventory.manager' | translate }}
                </span>
            </div>
        </header>
        <header class="mobile-second-header">
            <div class="d-flex align-items-center">
                <span class="lbl-org-stockroom">
                    <p class="mb-0 mr-3">
                        {{ 'organization' | translate | uppercase }} <br />
                        {{ 'stockroom' | translate | uppercase }}
                    </p>
                </span>
                <span class="mr-3 lbl-org-stockroom-val">
                    <p class="mb-0">
                        <strong *ngIf="currentOrgStockroom && isAdminConsole == 'No'">
                            {{ currentOrgStockroom.organization.orgName }}
                            <br />
                            {{ currentOrgStockroom.stockroom.stockroomName }}
                        </strong>
                    </p>
                </span>
                <button mat-stroked-button class="mx-1 change-btn" color="primary"
                    (click)="dialogChangeOrganizationStockroom()">
                    CHANGE
                </button>
            </div>
        </header>
        <section class="d-flex flex-grow-1 overflow-auto">
            <div class="w-100">
                <mat-accordion class="responsive-menu">
                    <mat-expansion-panel
                        (click)="navigateToPage(SITE_LINK.ADMIN_CONSOLE.BASE);analyticsEvent('Admin Console Organization Maintenance',  SITE_LINK.ADMIN_CONSOLE.BASE)"
                        hideToggle *ngIf="isAdminConsole == 'Yes'">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="responsive-route-title">
                                {{
                                'organization.maintenance'
                                | translate
                                }}
                            </mat-panel-title>
                            <mat-panel-description> </mat-panel-description>
                        </mat-expansion-panel-header>
                    </mat-expansion-panel>

                    <mat-expansion-panel
                        (click)="navigateToPage(SITE_LINK.ADMIN_ROLE_MAINTENANCE
                                                            .BASE);analyticsEvent('Admin Console Role Maintenance',  SITE_LINK.ADMIN_ROLE_MAINTENANCE.BASE)"
                        hideToggle *ngIf="isAdminConsole == 'Yes'">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="responsive-route-title">
                                {{ 'role.maintenance' | translate }}
                            </mat-panel-title>
                            <mat-panel-description> </mat-panel-description>
                        </mat-expansion-panel-header>
                    </mat-expansion-panel>
                    <mat-expansion-panel
                        (click)="navigateToPage(SITE_LINK.ADMIN_CONSOLE_NEWS_CENTER
                                                            .BASE);analyticsEvent('Admin Console Create News',  SITE_LINK.ADMIN_CONSOLE_NEWS_CENTER.BASE)"
                        hideToggle *ngIf="isAdminConsole == 'Yes'">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="responsive-route-title">
                                {{ 'create.news' | translate }}
                            </mat-panel-title>
                            <mat-panel-description> </mat-panel-description>
                        </mat-expansion-panel-header>
                    </mat-expansion-panel>

                    <mat-expansion-panel
                        (click)="navigateToAbsolutePage(SITE_LINK.ADMIN_SUPER_USERS_COUNTRY_VIEWS.SUPER_USERS);analyticsEvent('Country Admin/ Super User Maintenance', SITE_LINK.ADMIN_SUPER_USERS_COUNTRY_VIEWS.SUPER_USERS)"
                        hideToggle
                        *ngIf="isAdminConsole == 'Yes' && envDetails.isSuperUserandCountryAdminFeatureEnabled">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="responsive-route-title">
                                {{ 'ime.countryadmin.superuser.maintenance' | translate }}
                            </mat-panel-title>
                            <mat-panel-description> </mat-panel-description>
                        </mat-expansion-panel-header>
                    </mat-expansion-panel>

                    <mat-expansion-panel
                        (click)="navigateToPage(SITE_LINK.ADMIN_CONSOLE_LANGUAGE_KEY
                                                                                .BASE);analyticsEvent('Admin Console Language Keys',  SITE_LINK.ADMIN_CONSOLE_LANGUAGE_KEY.BASE)"
                        hideToggle *ngIf="isAdminConsole == 'Yes'">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="responsive-route-title">
                                {{ 'Language Keys' | translate }}
                            </mat-panel-title>
                            <mat-panel-description> </mat-panel-description>
                        </mat-expansion-panel-header>
                    </mat-expansion-panel>
                    <mat-expansion-panel
                        (click)="navigateToPage(SITE_LINK.SCHEDULING.BASE);analyticsEvent('Admin Console Scheduling', SITE_LINK.SCHEDULING.BASE)"
                        hideToggle *ngIf="isAdminConsole == 'Yes' && envDetails.isschedulerFeatureEnabled">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="responsive-route-title">
                                {{ 'Scheduling' | translate }}
                            </mat-panel-title>
                            <mat-panel-description> </mat-panel-description>
                        </mat-expansion-panel-header>
                    </mat-expansion-panel>
                    <mat-expansion-panel
                        (click)="navigateToPage(SITE_LINK.ADMIN_CONSOLE_SUPPORT_TICKET_REPORTS.BASE);analyticsEvent('Admin Console Support Ticket Reports', SITE_LINK.ADMIN_CONSOLE_SUPPORT_TICKET_REPORTS.BASE)"
                        hideToggle *ngIf="isAdminConsole == 'Yes' && isSupportTicketReportEnabled">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="responsive-route-title">
                                {{ 'Support Ticket Reports' | translate }}
                            </mat-panel-title>
                            <mat-panel-description> </mat-panel-description>
                        </mat-expansion-panel-header>
                    </mat-expansion-panel>
                    <mat-expansion-panel
                        (click)="navigateToPage(SITE_LINK.ADMIN_ORDER_TRACKING.BASE);analyticsEvent('Admin Console Order Tracking', SITE_LINK.ADMIN_ORDER_TRACKING.BASE)"
                        hideToggle
                        *ngIf="isAdminConsole == 'Yes' && envDetails.isAdminConsoleOrderTrackingFeatureEnabled">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="responsive-route-title">
                                {{ 'order.tracking' | translate }}
                            </mat-panel-title>
                            <mat-panel-description> </mat-panel-description>
                        </mat-expansion-panel-header>
                    </mat-expansion-panel>

                    <mat-expansion-panel
                        (click)="navigateToPage(SITE_LINK.ADMIN_MANAGE_BARCODING.BASE);analyticsEvent('Admin Console Barcode',  SITE_LINK.ADMIN_MANAGE_BARCODING.BASE)"
                        hideToggle *ngIf="isAdminConsole == 'Yes'">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="responsive-route-title">
                                {{ 'ime.barcode' | translate }}
                            </mat-panel-title>
                            <mat-panel-description> </mat-panel-description>
                        </mat-expansion-panel-header>
                    </mat-expansion-panel>

                    <mat-expansion-panel
                        (click)="navigateToPage(SITE_LINK.ADMIN_GLOBAL_METRICS.BASE);analyticsEvent('Global Metrics', SITE_LINK.ADMIN_GLOBAL_METRICS.BASE)"
                        hideToggle *ngIf="isAdminConsole == 'Yes' && envDetails.isGlobalMetricsFeatureEnabled">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="responsive-route-title">
                                {{ 'global.metrics' | translate }}
                            </mat-panel-title>
                            <mat-panel-description> </mat-panel-description>
                        </mat-expansion-panel-header>
                    </mat-expansion-panel>

                    <mat-expansion-panel
                        (click)="navigateToPage(SITE_LINK.ADMIN_DOWNLOAD_CENTER.BASE);analyticsEvent('Admin Console Download Center', SITE_LINK.ADMIN_DOWNLOAD_CENTER.BASE)"
                        hideToggle
                        *ngIf="isAdminConsole == 'Yes' && userType === 'SUPER_USER' && (envDetails.isSoftwareCenterFeatureEnabled || envDetails.isDownloadCenterFaqFeatureEnabled)">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="responsive-route-title">
                                {{ 'download.centre' | translate }}
                            </mat-panel-title>
                            <mat-panel-description> </mat-panel-description>
                        </mat-expansion-panel-header>
                    </mat-expansion-panel>
                    <mat-expansion-panel
                        (click)="navigateToPage(SITE_LINK.ADMIN_CENTER_ACTIVITY_LOG.BASE);analyticsEvent('Admin Center Activity Log', SITE_LINK.ADMIN_CENTER_ACTIVITY_LOG.BASE)"
                        hideToggle *ngIf="isAdminConsole == 'Yes'">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="responsive-route-title">
                                Admin Center Activity Log
                            </mat-panel-title>
                            <mat-panel-description> </mat-panel-description>
                        </mat-expansion-panel-header>
                    </mat-expansion-panel>

                    <mat-expansion-panel
                        (click)="navigateToPage(SITE_LINK.HOME.BASE);analyticsEvent('Dashboard',  SITE_LINK.HOME.BASE)"
                        hideToggle *ngIf="isAdminConsole == 'No'">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="responsive-route-title">
                                {{ 'dashboard' | translate }}
                            </mat-panel-title>
                            <mat-panel-description> </mat-panel-description>
                        </mat-expansion-panel-header>
                    </mat-expansion-panel>

                    <mat-expansion-panel *ngIf="isAdminConsole == 'No'">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="responsive-route-title">
                                {{ 'ime.activities' | translate }}
                            </mat-panel-title>
                            <mat-panel-description> </mat-panel-description>
                        </mat-expansion-panel-header>
                        <section class="responsive-routes">
                            <div class="mb-3" *ngIf="
                                    userData.isImssUser == 1
                                        ? true
                                        : userPrivileges.activities.consumeStock
                                        ? true
                                        : false
                                ">
                                <div class="link-title"
                                    (click)="close();analyticsEvent('Consume Stock',  SITE_LINK.ACTIVITY_CONSUME_STOCK.BASE)"
                                    [routerLink]="
                                        SITE_LINK.ACTIVITY_CONSUME_STOCK.BASE
                                    " *ngIf="
                                        userPrivileges.activities.consumeStock
                                    ">
                                    {{ 'consume.stock' | translate }}
                                </div>
                                <div class="disabled-link-title" *ngIf="
                                        !userPrivileges.activities.consumeStock
                                    ">
                                    <div #mobileEnterpriseLabel1 (click)="
                                            onEnterpriseClick(
                                                mobileEnterpriseLabel1
                                            )
                                        " class="enterpriseBlock">
                                        <div class="enterpriseText">E</div>
                                    </div>
                                    {{ 'consume.stock' | translate }}
                                </div>
                                <div class="link-description">
                                    {{ 'ime.consume.stock.desc' | translate }}
                                </div>
                            </div>

                            <div class="mb-3" *ngIf="
                                    userData.isImssUser === 1
                                        ? true
                                        : userPrivileges.activities.returnStock
                                        ? true
                                        : false
                                ">
                                <div class="link-title"
                                    (click)="close();analyticsEvent('Return Stock',  SITE_LINK.ACTIVITY_RETURN_STOCK.BASE)"
                                    [routerLink]="
                                        SITE_LINK.ACTIVITY_RETURN_STOCK.BASE
                                    " *ngIf="
                                        userPrivileges.activities.returnStock
                                    ">
                                    {{ 'return.stock' | translate }}
                                </div>
                                <div class="disabled-link-title" *ngIf="
                                        !userPrivileges.activities.returnStock
                                    ">
                                    <div #mobileEnterpriseLabel1 (click)="
                                            onEnterpriseClick(
                                                mobileEnterpriseLabel1
                                            )
                                        " class="enterpriseBlock">
                                        <div class="enterpriseText">E</div>
                                    </div>
                                    {{ 'return.stock' | translate }}
                                </div>
                                <div class="link-description">
                                    {{ 'ime.return.stock.desc' | translate }}
                                </div>
                            </div>

                            <div class="my-3" *ngIf="
                                    userData.isImssUser == 1
                                        ? true
                                        : userPrivileges.activities
                                              .replenishStock
                                        ? true
                                        : false
                                ">
                                <div>
                                    <div #mobileEnterpriseLabel2 (click)="
                                            onEnterpriseClick(
                                                mobileEnterpriseLabel2
                                            )
                                        " class="enterpriseBlock" *ngIf="
                                            !userPrivileges.activities
                                                .replenishStock
                                        ">
                                        <div class="enterpriseText">E</div>
                                    </div>
                                    <div [ngClass]="[
                                            userPrivileges.activities
                                                .replenishStock
                                                ? 'link-title'
                                                : 'disabled-link-title'
                                        ]"
                                        (click)="close();analyticsEvent('Replenish Stock Consumption',  SITE_LINK.ACTIVITY_REPLENISH_STOCK.BASE)"
                                        [routerLink]="
                                            SITE_LINK.ACTIVITY_REPLENISH_STOCK
                                                .BASE
                                        " *ngIf="
                                            replenishModel ===
                                            'CONSUMPTION_MODEL'
                                        ">
                                        {{ 'replenish.stock' | translate }}
                                    </div>
                                    <div [ngClass]="[
                                            userPrivileges.activities
                                                .replenishStock
                                                ? 'link-title'
                                                : 'disabled-link-title'
                                        ]"
                                        (click)="close();analyticsEvent('Replenish Stock Putaway',  SITE_LINK.ACTIVITY_REPLENISH_STOCK.PUT_AWAY)"
                                        [routerLink]="
                                            SITE_LINK.ACTIVITY_REPLENISH_STOCK
                                                .PUT_AWAY
                                        " *ngIf="
                                            replenishModel === 'PUTAWAY_MODEL'
                                        ">
                                        {{ 'replenish.stock' | translate }}
                                    </div>
                                    <div [ngClass]="[
                                            userPrivileges.activities
                                                .replenishStock
                                                ? 'link-title'
                                                : 'disabled-link-title'
                                        ]"
                                        (click)="close();analyticsEvent('Replenish Stock Onhand',  SITE_LINK.ACTIVITY_REPLENISH_STOCK.ON_HAND_MODE)"
                                        [routerLink]="
                                            SITE_LINK.ACTIVITY_REPLENISH_STOCK
                                                .ON_HAND_MODE
                                        " *ngIf="
                                            replenishModel === 'ON_HAND_MODEL'
                                        ">
                                        {{ 'replenish.stock' | translate }}
                                    </div>
                                    <div [ngClass]="[
                                            userPrivileges.activities
                                                .replenishStock
                                                ? 'link-title'
                                                : 'disabled-link-title'
                                        ]"
                                        (click)="close();analyticsEvent('Replenish Stock Issuance',  SITE_LINK.ACTIVITY_REPLENISH_STOCK.ISSUANCE_MODE)"
                                        [routerLink]="
                                            SITE_LINK.ACTIVITY_REPLENISH_STOCK
                                                .ISSUANCE_MODE
                                        " *ngIf="
                                            replenishModel === 'ISSUANCE_MODEL'
                                        ">
                                        {{ 'replenish.stock' | translate }}
                                    </div>
                                </div>
                                <div class="link-description" *ngIf="
                                        replenishModel === 'CONSUMPTION_MODEL'
                                    ">
                                    {{
                                    'ime.consumption.mode.desc' | translate
                                    }}
                                </div>
                                <div class="link-description" *ngIf="replenishModel === 'PUTAWAY_MODEL'">
                                    {{ 'ime.put.away' | translate | titlecase }}
                                </div>
                                <div class="link-description" *ngIf="replenishModel === 'ON_HAND_MODEL'">
                                    {{ 'on.hand' | translate | titlecase }}
                                </div>
                                <div class="link-description" *ngIf="replenishModel === 'ISSUANCE_MODEL'">
                                    {{
                                    'ime.replenish.issuance.mode.desc'
                                    | translate
                                    | titlecase
                                    }}
                                </div>
                            </div>
                            <div class="my-3" *ngIf="
                                    userData.isImssUser == 1
                                        ? true
                                        : userPrivileges.activities.receiveStock
                                        ? true
                                        : false
                                ">
                                <div class="link-title"
                                    (click)="close();analyticsEvent('Receive Stock',  SITE_LINK.ACTIVITY_RECEIVE_STOCK.BASE)"
                                    [routerLink]="
                                        SITE_LINK.ACTIVITY_RECEIVE_STOCK.BASE
                                    ">
                                    {{ 'receive.stock' | translate }}
                                </div>
                                <div class="disabled-link-title" *ngIf="
                                        !userPrivileges.activities.receiveStock
                                    ">
                                    <div #mobileEnterpriseLabel3 (click)="
                                            onEnterpriseClick(
                                                mobileEnterpriseLabel3
                                            )
                                        " class="enterpriseBlock">
                                        <div class="enterpriseText">E</div>
                                    </div>
                                    {{ 'receive.stock' | translate }}
                                </div>
                                <div class="link-description">
                                    {{ 'ime.receive.stock.desc' | translate }}
                                </div>
                            </div>

                            <div class="my-3" *ngIf="
                                    userData.isImssUser == 1
                                        ? true
                                        : userPrivileges.activities
                                              .createBarcodes
                                        ? true
                                        : false
                                ">
                                <div class="link-title" *ngIf="
                                        userPrivileges.activities.createBarcodes
                                    "
                                    (click)="close();analyticsEvent('Create Barcode',  SITE_LINK.ACTIVITY_CREATE_BARCODES.BASE)"
                                    [routerLink]="
                                        SITE_LINK.ACTIVITY_CREATE_BARCODES.BASE
                                    ">
                                    {{ 'create.barcodes' | translate }}
                                </div>
                                <div class="disabled-link-title" *ngIf="
                                        !userPrivileges.activities
                                            .createBarcodes
                                    ">
                                    <div #mobileEnterpriseLabel4 (click)="
                                            onEnterpriseClick(
                                                mobileEnterpriseLabel4
                                            )
                                        " class="enterpriseBlock">
                                        <div class="enterpriseText">E</div>
                                    </div>
                                    {{ 'create.barcodes' | translate }}
                                </div>
                                <div class="link-description">
                                    {{ 'ime.create.barcodes.desc' | translate }}
                                </div>
                            </div>

                            <div class="my-3" *ngIf="
                                    userData.isImssUser == 1
                                        ? true
                                        : userPrivileges.activities.approval
                                        ? true
                                        : false
                                ">
                                <div class="link-title with-badge"
                                    (click)="close();analyticsEvent('Approval',   SITE_LINK.APPROVAL.CONSUME_REQUEST_APPROVAL)"
                                    [routerLink]="
                                        SITE_LINK.APPROVAL
                                            .CONSUME_REQUEST_APPROVAL
                                    " routerLinkActive="router-link-active" *ngIf="userPrivileges.activities.approval">
                                    <span matBadge="{{ approvalCount?.totalCount|| 0 }}" matBadgeOverlap="false" *ngIf="
                                            userPrivileges.activities.approval
                                        ">
                                    </span>
                                    <span class="title">
                                        {{ 'approval' | translate }}
                                    </span>
                                </div>

                                <div class="disabled-link-title" *ngIf="!userPrivileges.activities.approval">
                                    <div #mobileEnterpriseLabel5 (click)="
                                            onEnterpriseClick(
                                                mobileEnterpriseLabel5
                                            )
                                        " class="enterpriseBlock">
                                        <div class="enterpriseText">E</div>
                                    </div>
                                    {{ 'approval' | translate }}
                                </div>

                                <div class="link-description">
                                    {{ 'ime.approval.desc' | translate }}
                                </div>
                            </div>

                            <ng-container *ngIf="
                                    replenishModel == 'CONSUMPTION_MODEL' ||
                                    replenishModel == 'ON_HAND_MODEL' ||
                                    replenishModel == 'PUTAWAY_MODEL'
                                ">
                                <div class="my-3" *ngIf="
                                        userType !== 'IMSS_USER' &&
                                        userPrivileges.activities.scannerFile
                                    ">
                                    <div class="link-title" (click)="palmRunOnHand(replenishModel)">
                                        {{
                                        'ime.scanner.file.replenishment'
                                        | translate
                                        }}
                                    </div>
                                    <div class="link-description" *ngIf="
                                            replenishModel == 'ON_HAND_MODEL'
                                        ">
                                        {{
                                        'ime.scanner.file.replenishment.desc'
                                        | translate
                                        }}
                                    </div>
                                    <div class="link-description" *ngIf="
                                            replenishModel == 'PUTAWAY_MODEL'
                                        ">
                                        {{
                                        'ime.put.away'
                                        | translate
                                        | titlecase
                                        }}
                                    </div>
                                    <div class="link-description" *ngIf="
                                            replenishModel ==
                                            'CONSUMPTION_MODEL'
                                        ">
                                        <ng-container *ngIf="
                                                palmRunInterpretation !==
                                                    'PUT_AWAY';
                                                else PUTAWAY
                                            ">
                                            {{
                                            'ime.scanner.file.replenishment.desc'
                                            | translate
                                            }}
                                        </ng-container>
                                        <ng-template #PUTAWAY>
                                            {{
                                            'ime.put.away'
                                            | translate
                                            | titlecase
                                            }}
                                        </ng-template>
                                    </div>
                                </div>
                            </ng-container>
                            <div class="my-3" *ngIf="
                                    replenishModel !== 'CONSUMPTION_MODEL' &&
                                    (userType == 'IMSS_USER' ||
                                        !userPrivileges.activities.scannerFile)
                                ">
                                <div class="disabled-link-title my-3" *ngIf="
                                        userType == 'IMSS_USER' ||
                                        !userPrivileges.activities.scannerFile
                                    ">
                                    <div #mobileEnterpriseLabel6 (click)="
                                            onEnterpriseClick(
                                                mobileEnterpriseLabel6
                                            )
                                        " class="enterpriseBlock">
                                        <div class="enterpriseText">E</div>
                                    </div>
                                    {{
                                    'ime.scanner.file.replenishment'
                                    | translate
                                    }}
                                </div>

                                <div class="link-description" *ngIf="replenishModel === 'ON_HAND_MODEL'">
                                    {{
                                    'ime.scanner.file.replenishment.desc'
                                    | translate
                                    }}
                                </div>
                                <div class="link-description" *ngIf="replenishModel === 'PUTAWAY_MODEL'">
                                    {{ 'ime.put.away' | translate | titlecase }}
                                </div>
                            </div>

                            <div class="mt-3" *ngIf="
                                    userData.isImssUser == 1
                                        ? true
                                        : userPrivileges.activities
                                              .stockCorrection
                                        ? true
                                        : false
                                ">
                                <div class="link-title" *ngIf="
                                        userPrivileges.activities
                                            .stockCorrection
                                    "
                                    (click)="close();analyticsEvent('Stock Correction',   SITE_LINK.ACTIVITY_STOCK_CORRECTION.BASE)"
                                    [routerLink]="
                                        SITE_LINK.ACTIVITY_STOCK_CORRECTION.BASE
                                    " routerLinkActive="router-link-active">
                                    {{ 'stock.correction' | translate }}
                                </div>
                                <div class="disabled-link-title my-3" *ngIf="
                                        !userPrivileges.activities
                                            .stockCorrection
                                    ">
                                    <div #mobileEnterpriseLabel7 (click)="
                                            onEnterpriseClick(
                                                mobileEnterpriseLabel7
                                            )
                                        " class="enterpriseBlock">
                                        <div class="enterpriseText">E</div>
                                    </div>
                                    {{ 'stock.correction' | translate }}
                                </div>
                                <div class="link-description">
                                    {{
                                    'ime.stock.correction.desc' | translate
                                    }}
                                </div>
                            </div>

                            <div class="mt-3" *ngIf="
                                    userData.isImssUser == 1
                                        ? true
                                        : userPrivileges.activities
                                              .transferStock
                                        ? true
                                        : false
                                ">
                                <div class="link-title" *ngIf="
                                        userPrivileges.activities
                                            .transferStock
                                    "
                                    (click)="close();analyticsEvent('Stock Transfer',   SITE_LINK.ACTIVITY_STOCK_TRANSFER.BASE)"
                                    [routerLink]="
                                        SITE_LINK.ACTIVITY_STOCK_TRANSFER.BASE
                                    " routerLinkActive="router-link-active">
                                    {{ 'ime.stock.transfer' | translate }}
                                </div>

                                <div class="link-description">
                                    {{
                                    'ime.transfer.stock.from.one.stockroom.to.another'
                                    | translate
                                    }}
                                </div>
                            </div>
                        </section>
                    </mat-expansion-panel>

                    <mat-expansion-panel *ngIf="isAdminConsole == 'No'">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="responsive-route-title">
                                {{ 'overview' | translate }}
                            </mat-panel-title>
                            <mat-panel-description> </mat-panel-description>
                        </mat-expansion-panel-header>
                        <section class="responsive-routes">
                            <div class="mb-3">
                                <div class="font-weight-bold">
                                    {{ 'overview' | translate | uppercase }}
                                </div>

                                <div *ngIf="
                                        userData.isImssUser == 1
                                            ? true
                                            : userPrivileges.overview.requests
                                            ? true
                                            : false
                                    ">
                                    <div class="link-title small my-3" *ngIf="userPrivileges.overview.requests"
                                        (click)="close();analyticsEvent('Requests',   SITE_LINK.REQUESTS.BASE)"
                                        [routerLink]="SITE_LINK.REQUESTS.BASE" routerLinkActive="router-link-active">
                                        {{ 'requests' | translate }}
                                    </div>
                                    <div class="disabled-link-title my-3" *ngIf="
                                            !userPrivileges.overview.requests
                                        ">
                                        <div #mobileEnterpriseLabel8 (click)="
                                                onEnterpriseClick(
                                                    mobileEnterpriseLabel8
                                                )
                                            " class="enterpriseBlock">
                                            <div class="enterpriseText">E</div>
                                        </div>
                                        {{ 'requests' | translate }}
                                    </div>
                                </div>

                                <div class="link-title small my-3" [routerLink]="SITE_LINK.ORDERS.BASE"
                                    (click)="close();analyticsEvent('Orders',   SITE_LINK.ORDERS.BASE)"
                                    routerLinkActive="router-link-active" *ngIf="userPrivileges.overview.orders">
                                    {{ 'orders' | translate }}
                                </div>
                                <div class="disabled-link-title my-3" *ngIf="!userPrivileges.overview.orders">
                                    <div #mobileEnterpriseLabel9 (click)="
                                            onEnterpriseClick(
                                                mobileEnterpriseLabel9
                                            )
                                        " class="enterpriseBlock">
                                        <div class="enterpriseText">E</div>
                                    </div>
                                    {{ 'orders' | translate }}
                                </div>

                                <div *ngIf="
                                        userData.isImssUser == 1
                                            ? true
                                            : userPrivileges.overview.products
                                            ? true
                                            : false
                                    ">
                                    <div class="link-title small my-3" *ngIf="userPrivileges.overview.products"
                                        (click)="close();analyticsEvent('Products',   SITE_LINK.PRODUCTS.BASE)"
                                        [routerLink]="SITE_LINK.PRODUCTS.BASE" routerLinkActive="router-link-active">
                                        {{ 'products' | translate }}
                                    </div>
                                    <div class="disabled-link-title my-3" *ngIf="
                                            !userPrivileges.overview.products
                                        ">
                                        <div #mobileEnterpriseLabel8 (click)="
                                                onEnterpriseClick(
                                                    mobileEnterpriseLabel8
                                                )
                                            " class="enterpriseBlock">
                                            <div class="enterpriseText">E</div>
                                        </div>
                                        {{ 'products' | translate }}
                                    </div>
                                </div>

                            </div>

                            <div class="my-3 mt-4">
                                <div class="font-weight-bold">
                                    {{ 'activity.log' | translate | uppercase }}
                                </div>

                                <div *ngIf="
                                        userData.isImssUser == 1
                                            ? true
                                            : userPrivileges.overview.articleLog
                                            ? true
                                            : false
                                    ">
                                    <div class="link-title small my-3" *ngIf="
                                            userPrivileges.overview.articleLog
                                        "
                                        (click)="close();analyticsEvent('Article Activity Log',   SITE_LINK.ACTIVITY_LOG.ARTICLE_ACTIVITY_LOG)"
                                        [routerLink]="
                                            SITE_LINK.ACTIVITY_LOG
                                                .ARTICLE_ACTIVITY_LOG
                                        ">
                                        {{ 'article.activity.log' | translate }}
                                    </div>
                                    <div class="disabled-link-title my-3" *ngIf="
                                            !userPrivileges.overview.articleLog
                                        ">
                                        <div #mobileEnterpriseLabel10 (click)="
                                                onEnterpriseClick(
                                                    mobileEnterpriseLabel10
                                                )
                                            " class="enterpriseBlock">
                                            <div class="enterpriseText">E</div>
                                        </div>
                                        {{ 'article.activity.log' | translate }}
                                    </div>
                                </div>

                                <div *ngIf="
                                        userData.isImssUser == 1
                                            ? true
                                            : userPrivileges.overview
                                                  .stockroomLog
                                            ? true
                                            : false
                                    ">
                                    <div class="link-title small my-3" *ngIf="
                                            userPrivileges.overview.stockroomLog
                                        "
                                        (click)="close();analyticsEvent('Stockroom Activity Log',   SITE_LINK.ACTIVITY_LOG.STOCKROOM_ACTIVITY_LOG)"
                                        [routerLink]="
                                            SITE_LINK.ACTIVITY_LOG
                                                .STOCKROOM_ACTIVITY_LOG
                                        ">
                                        {{
                                        'stockroom.activity.log'
                                        | translate
                                        | titlecase
                                        }}
                                    </div>
                                    <div class="disabled-link-title my-3" *ngIf="
                                            !userPrivileges.overview
                                                .stockroomLog
                                        ">
                                        <div #mobileEnterpriseLabel11 (click)="
                                                onEnterpriseClick(
                                                    mobileEnterpriseLabel11
                                                )
                                            " class="enterpriseBlock">
                                            <div class="enterpriseText">E</div>
                                        </div>
                                        {{
                                        'stockroom.activity.log'
                                        | translate
                                        | titlecase
                                        }}
                                    </div>
                                </div>
                                <div *ngIf="
                                                                        userData.isImssUser == 1
                                                                            ? true
                                                                            : userPrivileges.overview
                                                                                  .stockroomLog
                                                                            ? true
                                                                            : false
                                                                    ">
                                    <div class="link-title small my-3" *ngIf="
                                                                            userPrivileges.overview.stockroomLog
                                                                        "
                                        (click)="close();analyticsEvent('Site Activity Log',   SITE_LINK.ACTIVITY_LOG.SITE_ACTIVITY_LOG)"
                                        [routerLink]="
                                                                            SITE_LINK.ACTIVITY_LOG
                                                                                .SITE_ACTIVITY_LOG
                                                                        ">
                                        {{
                                        'ime.site.activity.log'
                                        | translate
                                        | titlecase
                                        }}
                                    </div>
                                    <div class="disabled-link-title my-3" *ngIf="
                                                                            !userPrivileges.overview
                                                                                .stockroomLog
                                                                        ">
                                        <div #mobileEnterpriseLabel11 (click)="
                                                                                onEnterpriseClick(
                                                                                    mobileEnterpriseLabel11
                                                                                )
                                                                            " class="enterpriseBlock">
                                            <div class="enterpriseText">E</div>
                                        </div>
                                        {{
                                        'ime.site.activity.log'
                                        | translate
                                        | titlecase
                                        }}
                                    </div>
                                </div>
                            </div>

                            <div class="my-3 mt-4">
                                <div class="font-weight-bold">
                                    {{ 'reporting' | translate | uppercase }}
                                </div>

                                <div *ngIf="
                                        userData.isImssUser == 1
                                            ? true
                                            : userPrivileges.overview.reporting
                                            ? true
                                            : false
                                    ">
                                    <div class="link-title small my-3" [routerLink]="SITE_LINK.REPORTING.BASE"
                                        (click)="close();analyticsEvent('Reports',   SITE_LINK.REPORTING.BASE)" *ngIf="
                                            userPrivileges.overview.reporting
                                        ">
                                        {{ 'reports' | translate }}
                                    </div>
                                    <div class="disabled-link-title my-3" *ngIf="
                                            !userPrivileges.overview.reporting
                                        ">
                                        <div #mobileEnterpriseLabel12 (click)="
                                                onEnterpriseClick(
                                                    mobileEnterpriseLabel12
                                                )
                                            " class="enterpriseBlock">
                                            <div class="enterpriseText">E</div>
                                        </div>
                                        {{ 'reports' | translate }}
                                    </div>
                                </div>
                            </div>
                            <div class="my-3 mt-4">
                                <div class="font-weight-bold">
                                    {{
                                    'order.tracking' | translate | uppercase
                                    }}
                                </div>

                                <div *ngIf="
                                        userData.isImssUser == 1
                                            ? true
                                            : userPrivileges.overview.trackOrder
                                            ? true
                                            : false
                                    ">
                                    <div class="link-title small my-3" [routerLink]="
                                            SITE_LINK.TRACK_ORDERS.BASE
                                        "
                                        (click)="close();analyticsEvent('Track Orders',   SITE_LINK.TRACK_ORDERS.BASE)"
                                        *ngIf="
                                            userPrivileges.overview.trackOrder
                                        ">
                                        {{ 'ime.track.orders' | translate }}
                                    </div>
                                    <div class="disabled-link-title my-3" *ngIf="
                                            !userPrivileges.overview.trackOrder
                                        ">
                                        <div #mobileEnterpriseLabel12 (click)="
                                                onEnterpriseClick(
                                                    mobileEnterpriseLabel12
                                                )
                                            " class="enterpriseBlock">
                                            <div class="enterpriseText">E</div>
                                        </div>
                                        {{ 'ime.track.orders' | translate }}
                                    </div>
                                </div>
                            </div>

                        </section>
                    </mat-expansion-panel>

                    <mat-expansion-panel *ngIf="isAdminConsole == 'No'">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="responsive-route-title">
                                {{ 'ime.administration' | translate }}
                            </mat-panel-title>
                            <mat-panel-description> </mat-panel-description>
                        </mat-expansion-panel-header>
                        <section class="responsive-routes">
                            <div class="mb-3">
                                <div class="font-weight-bold">
                                    {{ 'vendor' | translate | uppercase }}
                                </div>

                                <div class="link-title small my-3" [routerLink]="
                                        SITE_LINK.VENDOR_MAINTENANCE.BASE
                                    " routerLinkActive="router-link-active"
                                    (click)="close();analyticsEvent('Vendor Maintenance',   SITE_LINK.VENDOR_MAINTENANCE.BASE)"
                                    *ngIf="
                                        userPrivileges.administration
                                            .vendorMaintenance
                                    ">
                                    {{ 'vendor.maintenance' | translate }}
                                </div>
                                <div class="link-title small my-3" [routerLink]="SITE_LINK.INTEGRATION_MAINTENANCE.BASE"
                                    routerLinkActive="router-link-active"
                                    (click)="close();analyticsEvent('Integration Maintenance',   SITE_LINK.INTEGRATION_MAINTENANCE.BASE)"
                                    *ngIf="userPrivileges.administration.integrationMaintenance">
                                    {{ 'ime.integration.maintenance' | translate }}
                                </div>
                            </div>
                            <div class="my-3 mt-4">
                                <div class="font-weight-bold">
                                    {{ 'stockroom' | translate | uppercase }}
                                </div>

                                <div *ngIf="
                                        userData.isImssUser == 1
                                            ? true
                                            : userPrivileges.administration
                                                  .manageStockroom
                                            ? true
                                            : false
                                    ">
                                    <div class="link-title small my-3" *ngIf="
                                            userPrivileges.administration
                                                .manageStockroom
                                        "
                                        (click)="close();analyticsEvent('Manage Stockroom',   SITE_LINK.MANAGE_STOCKROOM.BASE)"
                                        [routerLink]="
                                            SITE_LINK.MANAGE_STOCKROOM.BASE
                                        ">
                                        {{ 'manage.stockroom' | translate }}
                                    </div>
                                    <div class="disabled-link-title my-3" *ngIf="
                                            !userPrivileges.administration
                                                .manageStockroom
                                        ">
                                        <div #mobileEnterpriseLabel13 (click)="
                                                onEnterpriseClick(
                                                    mobileEnterpriseLabel13
                                                )
                                            " class="enterpriseBlock">
                                            <div class="enterpriseText">E</div>
                                        </div>
                                        {{ 'manage.stockroom' | translate }}
                                    </div>
                                </div>

                                <div *ngIf="
                                        userData.isImssUser == 1
                                            ? true
                                            : userPrivileges.administration
                                                  .exportImportStockroom
                                            ? true
                                            : false
                                    ">
                                    <div class="link-title small my-3" *ngIf="
                                            userPrivileges.administration
                                                .exportImportStockroom
                                        "
                                        (click)="close();analyticsEvent('Export Import Stockroom',   SITE_LINK.EXPORT_IMPORT_STOCKROOM.BASE)"
                                        [routerLink]="
                                            SITE_LINK.EXPORT_IMPORT_STOCKROOM
                                                .BASE
                                        ">
                                        {{
                                        'exportimport.stockroom' | translate
                                        }}
                                    </div>
                                    <div class="disabled-link-title my-3" *ngIf="
                                            !userPrivileges.administration
                                                .exportImportStockroom
                                        ">
                                        <div #mobileEnterpriseLabel21 (click)="
                                                onEnterpriseClick(
                                                    mobileEnterpriseLabel21
                                                )
                                            " class="enterpriseBlock">
                                            <div class="enterpriseText">E</div>
                                        </div>
                                        {{
                                        'exportimport.stockroom' | translate
                                        }}
                                    </div>
                                </div>

                                <div *ngIf="
                                        userData.isImssUser == 1
                                            ? true
                                            : userPrivileges.administration
                                                  .locationMaintenance
                                            ? true
                                            : false
                                    ">
                                    <div class="link-title small my-3" *ngIf="
                                            userPrivileges.administration
                                                .locationMaintenance
                                        "
                                        (click)="close();analyticsEvent('Location Maintenance',   SITE_LINK.LOCATION_MAINTENANCE.BASE)"
                                        [routerLink]="
                                            SITE_LINK.LOCATION_MAINTENANCE.BASE
                                        ">
                                        {{ 'location.maintenance' | translate }}
                                    </div>
                                    <div class="disabled-link-title my-3" *ngIf="
                                            !userPrivileges.administration
                                                .locationMaintenance
                                        ">
                                        <div #mobileEnterpriseLabel14 (click)="
                                                onEnterpriseClick(
                                                    mobileEnterpriseLabel14
                                                )
                                            " class="enterpriseBlock">
                                            <div class="enterpriseText">E</div>
                                        </div>
                                        {{ 'location.maintenance' | translate }}
                                    </div>
                                </div>
                            </div>
                            <div class="my-3 mt-4">
                                <div class="font-weight-bold">
                                    {{ 'im.product' | translate | uppercase }}
                                </div>

                                <div *ngIf="
                                        userData.isImssUser == 1
                                            ? true
                                            : userPrivileges.administration
                                                  .productMaintenance
                                            ? true
                                            : false
                                    ">
                                    <div class="link-title small my-3" *ngIf="
                                            userPrivileges.administration
                                                .productMaintenance
                                        "
                                        (click)="close();analyticsEvent('Product Maintenance',   SITE_LINK.PRODUCT_MAINTENANCE.BASE)"
                                        [routerLink]="
                                            SITE_LINK.PRODUCT_MAINTENANCE.BASE
                                        ">
                                        {{ 'product.maintenance' | translate }}
                                    </div>
                                    <div class="disabled-link-title my-3" *ngIf="
                                            !userPrivileges.administration
                                                .productMaintenance
                                        ">
                                        <div #mobileEnterpriseLabel15 (click)="
                                                onEnterpriseClick(
                                                    mobileEnterpriseLabel15
                                                )
                                            " class="enterpriseBlock">
                                            <div class="enterpriseText">E</div>
                                        </div>
                                        {{ 'product.maintenance' | translate }}
                                    </div>
                                </div>

                                <div *ngIf="
                                        userData.isImssUser == 1
                                            ? true
                                            : userPrivileges.administration
                                                  .reference
                                            ? true
                                            : false
                                    ">
                                    <div class="link-title small my-3" *ngIf="
                                            userPrivileges.administration
                                                .reference
                                        " [routerLink]="
                                            SITE_LINK.REFERENCE_CODE_FIELD_UOM
                                                .BASE
                                        "
                                        (click)="close();analyticsEvent('Reference Code Field UOM',   SITE_LINK.REFERENCE_CODE_FIELD_UOM.BASE)">
                                        {{
                                        'ime.reference.code.field.uom'
                                        | translate
                                        }}
                                    </div>
                                    <div class="disabled-link-title my-3" *ngIf="
                                            !userPrivileges.administration
                                                .reference
                                        ">
                                        <div #mobileEnterpriseLabel16 (click)="
                                                onEnterpriseClick(
                                                    mobileEnterpriseLabel16
                                                )
                                            " class="enterpriseBlock">
                                            <div class="enterpriseText">E</div>
                                        </div>
                                        {{
                                        'ime.reference.code.field.uom'
                                        | translate
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="my-3 mt-4">
                                <div class="font-weight-bold">
                                    {{ 'user' | translate | uppercase }}
                                </div>

                                <div *ngIf="
                                        userData.isImssUser == 1
                                            ? true
                                            : userPrivileges.administration
                                                  .userMaintenance
                                            ? true
                                            : false
                                    ">
                                    <div class="link-title small my-3" *ngIf="
                                            userPrivileges.administration
                                                .userMaintenance
                                        "
                                        (click)="close();analyticsEvent('User Maintenance',   SITE_LINK.USER_MAINTENANCE.BASE)"
                                        [routerLink]="
                                            SITE_LINK.USER_MAINTENANCE.BASE
                                        ">
                                        {{ 'user.maintenance' | translate }}
                                    </div>
                                    <div class="disabled-link-title my-3" *ngIf="
                                            !userPrivileges.administration
                                                .userMaintenance
                                        ">
                                        <div #mobileEnterpriseLabel17 (click)="
                                                onEnterpriseClick(
                                                    mobileEnterpriseLabel17
                                                )
                                            " class="enterpriseBlock">
                                            <div class="enterpriseText">E</div>
                                        </div>
                                        {{ 'user.maintenance' | translate }}
                                    </div>
                                </div>

                                <div *ngIf="
                                        userData.isImssUser == 1
                                            ? true
                                            : userPrivileges.administration
                                                  .costCenter
                                            ? true
                                            : false
                                    ">
                                    <div class="link-title small my-3" *ngIf="
                                            userPrivileges.administration
                                                .costCenter
                                        "
                                        (click)="close();analyticsEvent('Cost Center Maintenance',   SITE_LINK.COST_CENTER_MAINTENANCE.BASE)"
                                        [routerLink]="
                                            SITE_LINK.COST_CENTER_MAINTENANCE
                                                .BASE
                                        ">
                                        {{
                                        'cost.center.maintenance'
                                        | translate
                                        }}
                                    </div>
                                    <div class="disabled-link-title my-3" *ngIf="
                                            !userPrivileges.administration
                                                .costCenter
                                        ">
                                        <div #mobileEnterpriseLabel18 (click)="
                                                onEnterpriseClick(
                                                    mobileEnterpriseLabel18
                                                )
                                            " class="enterpriseBlock">
                                            <div class="enterpriseText">E</div>
                                        </div>
                                        {{
                                        'cost.center.maintenance'
                                        | translate
                                        }}
                                    </div>
                                </div>

                                <div *ngIf="
                                        userData.isImssUser == 1
                                            ? true
                                            : userPrivileges.administration
                                                  .deptMaintenance
                                            ? true
                                            : false
                                    ">
                                    <div class="link-title small my-3" [routerLink]="
                                            SITE_LINK.DEPARTMENT_MAINTENANCE
                                                .BASE
                                        "
                                        (click)="close();analyticsEvent('Department Maintenance',   SITE_LINK.DEPARTMENT_MAINTENANCE.BASE)"
                                        *ngIf="
                                            userPrivileges.administration
                                                .deptMaintenance
                                        ">
                                        {{
                                        'department.maintenance' | translate
                                        }}
                                    </div>
                                    <div class="disabled-link-title my-3" *ngIf="
                                            !userPrivileges.administration
                                                .deptMaintenance
                                        ">
                                        <div #mobileEnterpriseLabel19 (click)="
                                                onEnterpriseClick(
                                                    mobileEnterpriseLabel19
                                                )
                                            " class="enterpriseBlock">
                                            <div class="enterpriseText">E</div>
                                        </div>
                                        {{
                                        'department.maintenance' | translate
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="my-3 mt-4">
                                <div class="font-weight-bold">
                                    {{
                                    'ime.administration'
                                    | translate
                                    | uppercase
                                    }}
                                </div>

                                <div *ngIf="
                                        userData.isImssUser == 1
                                            ? true
                                            : userPrivileges.administration
                                                  .reasonCode
                                            ? true
                                            : false
                                    ">
                                    <div class="link-title small my-3" *ngIf="
                                            userPrivileges.administration
                                                .reasonCode
                                        "
                                        (click)="close();analyticsEvent('Reason Code Maintenance',   SITE_LINK.REASON_CODE_MAINTENANCE.BASE)"
                                        [routerLink]="
                                            SITE_LINK.REASON_CODE_MAINTENANCE
                                                .BASE
                                        ">
                                        {{
                                        'reason.code.maintenance'
                                        | translate
                                        }}
                                    </div>
                                    <div class="disabled-link-title my-3" *ngIf="
                                            !userPrivileges.administration
                                                .reasonCode
                                        ">
                                        <div #mobileEnterpriseLabel20 (click)="
                                                onEnterpriseClick(
                                                    mobileEnterpriseLabel20
                                                )
                                            " class="enterpriseBlock">
                                            <div class="enterpriseText">E</div>
                                        </div>
                                        {{
                                        'reason.code.maintenance'
                                        | translate
                                        }}
                                    </div>
                                </div>

                                <div
                                    *ngIf="userData.isImssUser == 1? true: userPrivileges.administration.messageCenter? true: false">
                                    <div class="link-title small my-3"
                                        *ngIf="userPrivileges.administration.messageCenter"
                                        (click)="close();analyticsEvent('Message Center',   SITE_LINK.MESSAGE_CENTER.BASE)"
                                        [routerLink]="SITE_LINK.MESSAGE_CENTER.BASE">

                                        {{ 'messaging.center' | translate }}

                                    </div>
                                    <div class="disabled-link-title my-3"
                                        *ngIf="!userPrivileges.administration.messageCenter">
                                        <div #mobileEnterpriseLabel20
                                            (click)="onEnterpriseClick(mobileEnterpriseLabel20)"
                                            class="enterpriseBlock">
                                            <div class="enterpriseText">E</div>
                                        </div>
                                        {{ 'messaging.center' | translate }}
                                    </div>
                                </div>
                                <div *ngIf="
                                        isShowAdminConsole ||
                                        isCountryAdminViewOnly
                                    ">
                                    <div class="link-title small my-3" *ngIf="
                                        isShowAdminConsole ||
                                        isCountryAdminViewOnly" (click)="
                                            naivgateToAdminConosleOrgView();analyticsEvent('Message Center',   'app/admin/organization/organization-maintenance/manage-organization/required-settings-normal')
                                        ">

                                        {{ 'organization.maintenance' | translate }}

                                    </div>

                                </div>
                            </div>
                        </section>
                    </mat-expansion-panel>

                    <mat-expansion-panel *ngIf="userPrivileges.downloadCenter && isAdminConsole == 'No'" (click)="
                            navigateToPage(
                                'download-center/software-and-manuals'
                            );analyticsEvent('Message Center','download-center/software-and-manuals')
                        " hideToggle>
                        <mat-expansion-panel-header>
                            <mat-panel-title class="responsive-route-title">
                                {{ 'download.centre' | translate }}
                            </mat-panel-title>
                            <mat-panel-description> </mat-panel-description>
                        </mat-expansion-panel-header>
                    </mat-expansion-panel>

                </mat-accordion>
            </div>
        </section>
    </div>
</section>
